import { If, ifElse } from 'aa_common/front-end'
import { EXCISE_TAX_METHOD } from 'common/constants'
import { yen } from 'common/helpers'
import { getNs } from 'common/i18n-config'
import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import React from 'react'
import { useSelector } from 'react-redux'
import { getExciseSettingsByDateList } from 'store/settings/excise/selectors'

import { TableWrapper } from './styles'

type Props = {
  data: any
  styles?: object
}

const { t, useNsReady } = getNs(['components/organisms/assets/asset-detail'])

export const AssetReductionInformation = ({ data, styles }: Props) => {
  useNsReady()
  const { isEnable: isEnableForReduction } = useCheckFlag(FeatureFlagNames.FixedAssetReduction)

  const { data: exciseSetting } = useSelector(getExciseSettingsByDateList, isEqual)
  const isTaxMethodExcluded = exciseSetting?.tax_method === EXCISE_TAX_METHOD.EXCLUDED_TAX
  const acquisitionCost = ifElse(
    isTaxMethodExcluded,
    get(data, 'acquisition_cost_excluded_excise'),
    get(data, 'acquisition_cost')
  )
  const subsidyAmount = get(data, 'subsidy_amount')
  const reductionAmount = get(data, 'reduction_amount')

  return (
    <If condition={isEnableForReduction && subsidyAmount && reductionAmount}>
      <TableWrapper style={{ marginTop: 10 }} theme={styles}>
        <tbody>
          <tr>
            <th>{t('subsidy_amount')}</th>
            <td>{yen(subsidyAmount)}</td>
            <th>{t('net_acquisition_cost')}</th>
            <td>{yen(acquisitionCost - subsidyAmount)}</td>
          </tr>
          <tr>
            <th>{t('reduction_amount')}</th>
            <td>{yen(reductionAmount)}</td>
            <th>{t('reduced_acquisition_cost')}</th>
            <td>{yen(acquisitionCost - reductionAmount)}</td>
          </tr>
        </tbody>
      </TableWrapper>
    </If>
  )
}
